//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TalksMap from "@/utils/initMapTalks.js";
export default {
  name: "LandResources",
  data() {
    return {
      filterForm: {
        croplandVillGroup: "", // 村组
        croplandType: "", // 土地属性
      },
      villGroups: [], // 所有的村小组
      croplandTypeData: [
        { id: 2, name: "耕地" },
        { id: 3, name: "园地" },
        { id: 4, name: "林地" },
        { id: 5, name: "草地" },
        { id: 6, name: "湿地" },
        { id: 7, name: "城镇村及工矿用地" },
        { id: 8, name: "交通运输用地" },
        { id: 9, name: "水域及水利设施用地" },
      ],
      TalksMapDialog: new TalksMap(),
      landList: [], // 所有的地块
      mapTopInfoOptions: {
        data: [
          { id: 2, name: "耕地", colour: "#985523" },
          { id: 3, name: "园地", colour: "#95de64" },
          { id: 4, name: "林地", colour: "#52c41a" },
          { id: 5, name: "草地", colour: "#03973e" },
          { id: 6, name: "湿地", colour: "#00bff6" },
          { id: 7, name: "城镇村及工矿用地", colour: "#e29e00" },
          { id: 8, name: "交通运输用地", colour: "#722ed1" },
          { id: 9, name: "水域及水利设施用地", colour: "#597ef7" },
        ],
      },
      curGroupInfo: {}, // 当前选择的村组信息
      dialogGroupVisible: false, // 去设置村组
      masterId: "",
      coordinate: [116.177427669, 28.861500052],
    };
  },
  watch: {
    landList: {
      handler: function (n) {
        if (this.landList.length > 0) {
          let lng, lat;
          let temp = JSON.parse(this.landList[0].centroid).coordinates;
          lng = temp[0];
          lat = temp[1];
          let Coordinate = {
            x: lng,
            y: lat,
          };
          this.coordinate = Coordinate;
        }
        this.TalksMapDialog.land(
          this.landList,
          "croplandEdge",
          "",
          true,
          true,
          this.landPolygonMouseenter
        );
      },
    },
  },
  computed: {
    dialogGroupChoiceClass() {
      let villGroups = this.villGroups,
        len = villGroups.length,
        className = "";
      if (len > 30) {
        className = "class2";
      } else if (len > 20) {
        className = "class2";
      } else if (len > 10) {
        className = "class2";
      } else {
        className = "class1";
      }
      return className;
    },
  },
  mounted() {
    this.masterId = this.$route.query.$businessAccountId;
    this.TalksMapDialog.sendThis(this);
    this.getMapInit();
    this.getVillGroups();
    this.getLandList();
  },
  methods: {
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2022-12-29 09:12:20
     * @return {*}
     */
    initialAddress() {
      this.TalksMapDialog.map.setCenter(this.coordinate);
    },
    /**
     * @descripttion: 切换村小组
     * @Author: juanjuanhui
     * @Date: 2022-01-08 09:28:58
     * @param {*} item 当前数据项
     */
    handleChangeVillGroup(item) {
      this.curGroupInfo = item;
    },
    /**
     * @descripttion: 去设置村组
     * @Author: juanjuanhui
     * @Date: 2022-01-03 17:45:08
     */
    handleSetGroup() {
      this.$router.push({ path: "/system/organize" });
    },
    /**
     * @descripttion: 选择村组
     * @Author: juanjuanhui
     * @Date: 2022-01-03 17:41:37
     * @param {*} item
     */
    handleSelGroup(item) {
      this.curGroupInfo = item;
    },
    /**
     * @descripttion: 获取村小组数据
     * @Author: juanjuanhui
     * @Date: 2021-12-20 11:22:32
     */
    getVillGroups() {
      this.$http.common
        .getVillGroups({ masterId: this.masterId })
        .then((res) => {
          this.villGroups = res.data;
        });
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getLandList(params) {
      params = params ? params : {};
      params.accountId = this.masterId;
      this.$http.village.getLandList(params).then((res) => {
        this.landList = res.data;
      });
    },
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("mapDiv", 16);
    },
    /**
     * @descripttion: 筛选地图
     * @Author: juanjuanhui
     * @Date: 2021-12-07 13:54:40
     */
    handleFilterMap() {
      let params = {
        croplandVillGroupId: this.filterForm.croplandVillGroup.id, // 村组
        croplandType: this.filterForm.croplandType,
      };
      this.getLandList(params);
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-12-14 10:40:34
     * @param {*} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.getLandList();
    },
    /**
     * @descripttion: 地图鼠标悬浮效果
     * @Author: juanjuanhui
     * @Date: 2022-01-20 21:06:20
     * @param {*} e
     */
    landPolygonMouseenter(e) {
      var options = {};
      this.$http.work.getLandDetail({ id: e.target.val.id }).then((res) => {
        let detail = res.data;
        options = {
          single: true,
          title: false,
          autoOpenOn: null, //单击地图时不打开窗口，则设置为null
          content: `<div class="map-info-box">
            <div class="msg-header">
              <p class="title">地块信息</p>
            </div>
            <div class="msg-body">
              <ul class="list">
                <li class="item">土地归属：${detail.croplandVillGroupName}</li>
                <li class="item">地块编号：${detail.croplandId}</li>
                <li class="item">土地属性：${detail.croplandTypeName}</li>
                <li class="item">地块面积：${detail.croplandArea}亩</li>
                <li class="item">地块周长：${detail.croplandPerimeter}米</li>
                <li class="item">位置描述：${
                  detail.address ? detail.address : ""
                }</li>
              </ul>
            </div>
          </div>`,
          autoPan: false, //弹窗边界不移动地图
          width: 300,
          custom: false,
        };
        e.target.setInfoWindow(options);
        e.target.openInfoWindow();
      });
    },
  },
};
